import localeData from '../es/locale-data.json';
import backend from '../es/backend.json';

export default {
  ...localeData,
  ...backend,
} as Record<string, string>;
